<app-tab-navigation-header [title]="title">
	<mat-tab-group appQueryStringTabGroup (selectedIndexChange)="changeTitle($event)">
		<mat-tab label="All Users" i18n-label="@@userMainTab-allLabel" data-automation-id="all-users-tab">
			<ng-template matTabContent>
				<app-user-directory [appBreadcrumbLabel]="userTitle"></app-user-directory>
			</ng-template>
		</mat-tab>

		@if (canSeeWhitelistTab && !canSeeWhitelistUsers) {
			<mat-tab label="Whitelist" i18n-label="@@userMainTab-whitelist" data-automation-id="whitelist-user-tab">
				<ng-template matTabContent>
					<app-user-whitelist
						[appBreadcrumbLabel]="whiteListBreadcrumbLabel"
						(whitelistPageSelectionChanged)="onWhitelistPageSelectionChanged($event)"
					>
					</app-user-whitelist>
				</ng-template>
			</mat-tab>
		}

		@if (canSeeWhitelistTab && canSeeWhitelistUsers) {
			<mat-tab label="Whitelist" i18n-label="@@userMainTab-whitelistUsers" data-automation-id="all-whitelist-users-tab">
				<ng-template matTabContent>
					<app-user-directory
						[appBreadcrumbLabel]="whiteListBreadcrumbLabel"
						[showWhitelistedUsers]="true"
						(whitelistPageSelectionChanged)="onWhitelistPageSelectionChanged($event)"
					>
					</app-user-directory>
				</ng-template>
			</mat-tab>
		}
	</mat-tab-group>
</app-tab-navigation-header>
